import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${props => props.theme.spacing.sp24};
`

export const LegendContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`

export const LegendSquare = styled.div`
  width: ${props => props.theme.size['3XS']};
  height: ${props => props.theme.size['3XS']};
  background-color: ${props => props.backgroundColor};
  border-radius: 2px;
`

export const LegendLine = styled.div`
  width: ${props => props.theme.size.XXS};
  height: 1px;
  background-color: ${props => props.backgroundColor};
`
